export const VALIDA_DOC_LOAD = 'VALIDA_DOC_LOAD';
export const VALIDA_DOC_TOKEN = 'VALIDA_DOC_TOKEN';
export const VALIDA_DOC_RETORNO = 'VALIDA_DOC_RETORNO';


